<p>
  <mat-toolbar color="primary">
    <button mat-icon-button aria-label="Example icon-button with menu icon" (click)="drawer.toggle()" name="menuButton">
      <mat-icon>menu</mat-icon>
    </button>
    <span>ECRF</span>
    <span class="example-spacer"></span>
    <span>{{ user.username }}</span>
    <button mat-icon-button class="example-icon favorite-icon" (click)="goHome()">
      <mat-icon>home</mat-icon>
    </button>
    <button mat-icon-button [matMenuTriggerFor]="menuLang" aria-label="Example icon-button with a menu">
      <mat-icon>g_translate</mat-icon>
    </button>
    <mat-menu #menuLang="matMenu">
      <button mat-menu-item (click)="useLanguage('en')">
        <mat-icon>language</mat-icon>
        <span>English</span>
      </button>
      <button mat-menu-item (click)="useLanguage('it')">
        <mat-icon>language</mat-icon>
        <span>Italiano</span>
      </button>
    </mat-menu>
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      <mat-icon>person_filled</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="goChangePass()">
        <mat-icon>settings</mat-icon>
        <span>{{ 'ChP' | translate }}</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>{{ 'Lgt' | translate }}</span>
      </button>
    </mat-menu>
  </mat-toolbar>
</p>
<mat-drawer-container class="example-container">
  <mat-drawer #drawer class="example-sidenav" mode="side" [(opened)]="opened" (opened)="sideNavOpen()" (closed)="sideNavClose()">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <!-- use a disabled button to provide padding for tree leaf -->
        <button mat-flat-button (click)="goRoute(node.name)">{{ this.getNodeName(node.name) }}</button>
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        {{this.getNodeName(node.name)}}
      </mat-tree-node>
    </mat-tree>
  </mat-drawer>

  <div class="example-sidenav-content">
    <router-outlet></router-outlet>
  </div>

</mat-drawer-container>
<app-alert></app-alert>
